import { getDeviceSize } from '~/utils/device'

export default {
  props: {
    title: {
      type: String,
    },
    imageMobile: {
      type: Object,
    },
    imageDesktop: {
      type: Object,
    },
  },

  data() {
    return {
      isMobile: null,
      image: null,
    }
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.resize)
      window.dispatchEvent(new Event('resize'))
    })
  },

  destroyed() {
    window.removeEventListener('resize', this.resize)
  },

  methods: {
    resize(e) {
      this.checkDeviceSize(e, this)
    },

    checkDeviceSize() {
      const device = getDeviceSize()
      this.isMobile = /mobile|tablet(?:\-(?:l|[m]))?/.test(device)

      this.image = this.isMobile ? this.imageMobile : this.imageDesktop
    },
  },
}
